import React from "react";
import { Form as FormikForm, useFormikContext } from "formik";

import { ErrorPanel } from "affinityUI/form/components";

export const Form: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isValid, isValidating, errors } = useFormikContext();

  return (
    <FormikForm noValidate>
      <>
        {!isValid && !isValidating && <ErrorPanel errors={errors} />}
        {children}
      </>
    </FormikForm>
  );
};
